<template>
  <v-card class="px-10 py-5">
    <v-card-title class="headline">
      Create customer
    </v-card-title>
    <v-progress-circular
      v-if="isLoading"
      :size="60"
      :width="8"
      class="d-block mx-auto mt-16"
      indeterminate
      color="primary"
    />
    <v-form
      v-if="!isLoading"
      ref="form"
      v-model="formCustomer.valid"
    >
      <v-row>
        <v-col>
          <v-text-field
            v-model="formCustomer.no"
            :rules="formCustomer.noRules"
            label="Customer No"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="formCustomer.name"
            :rules="formCustomer.nameRules"
            label="Customer Name"
            required
          />
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-2" text :disabled="isLoading" @click="$emit('close')">
          Cancel
        </v-btn>
        <v-btn
          color="light-blue darken-2"
          :disabled="isLoading"
          text
          @click="doCreateCustomer"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { createCustomer } from 'API/customer';

export default {
  data: () => ({
    isLoading: false,
    formCustomer: {
      valid: true,
      no: '',
      noRules: [
        (v) => !!v || 'No is required',
      ],
      name: '',
      nameRules: [
        (v) => !!v || 'Name is required',
      ],
    },
    error: {
      status: false,
      message: '',
    },
  }),
  methods: {
    async doCreateCustomer() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      const { __raw: jwt = '' } = await this.$auth.getIdTokenClaims();
      const body = {
        no: this.formCustomer.no,
        name: this.formCustomer.name,
      };

      try {
        const res = await createCustomer(jwt, body);
        this.$emit('created', res.data);
        this.$emit('close');
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      } catch (error) {
        this.error.status = true;
        this.error.message = error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
